const isBrowser = typeof window !== "undefined" && !!window.localStorage;

const safeGet = key => {
  if (!isBrowser) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, val) => {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(key, val);
  } catch (error) {
    console.warn(`localStorage.setItem failed for key "${key}":`, error.message);
  }
};

const safeRemove = key => {
  if (isBrowser)
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
    console.warn(`localStorage.removeItem failed for key "${key}":`, error.message);
  }
};
const safeClear = () => {
  if (isBrowser)
    try {
      window.localStorage.clear();
    } catch (error) {
    console.warn(`localStorage.clear failed for key "${key}":`, error.message);
  }
};

export const storage = {
  set(key, value) {
    if (typeof value === 'object' && value !== null) {
      console.warn(`Use setObj() for object values. Converting ${key} to string.`);
    }
    safeSet(key, String(value));
  },
  get(key, defaultValue) {
    const v = safeGet(key);
    return v == null ? defaultValue : v;
  },
  setObj(key, value) {
    try {
      safeSet(key, JSON.stringify(value));
    } catch {}
  },
  getObj(key, defaultValue) {
    const v = safeGet(key);
    if (v == null || v === "") return defaultValue ?? false;
    try {
      return JSON.parse(v);
    } catch {
      return defaultValue ?? false;
    }
  },
  remove(key) {
    safeRemove(key);
  },
  clear() {
    safeClear();
  }
};
